import React from 'react';
import styled from 'styled-components';
import Text from './Text';
import Markdown from 'markdown-to-jsx';
import { StyledLongCaption } from './resultsStyles';

const StyledUl = styled.ul``;
const StyledOl = styled.ol``;

const StyledLi = styled.li``;

export default function List({ list, textType, textStyles, type = 'ul' }) {
  const StyledList = type === 'ul' ? StyledUl : StyledOl;
  return (
    <StyledList>
      {list.map((element) => (
        <StyledLi>
          <Text styles={textStyles} type={textType}>
            <Markdown>{element}</Markdown>
          </Text>
        </StyledLi>
      ))}
    </StyledList>
  );
}
